// extracted by mini-css-extract-plugin
export var csatScore = "_jb-5";
export var header = "_jb-1";
export var panelWrapper = "_jb-2";
export var postPreview = "_jb-3";
export var rightContent = "_jb-0";
export var wrappingText = "_jb-4";